import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PrimaryButton } from "../components/buttons/StyledButton";
import ElectricalPlug from "../assets/imgs/notFound/ElectricalPlug";
import CircleIcon28pxSvg from "../assets/imgs/notFound/CircleIcon28pxSvg";
import CircleIcon64pxSvg from "../assets/imgs/notFound/CircleIcon64pxSvg";
import CircleIcon83pxSvg from "../assets/imgs/notFound/CircleIcon83pxSvg";
import Xicon24pxSvg from "../assets/imgs/notFound/Xicon24pxSvg";
import XIcon52pxSvg from "../assets/imgs/notFound/XIcon52pxSvg";
import Xicon71pxSvg from "../assets/imgs/notFound/Xicon71pxSvg";

const NotFound = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className="relative mt-[80px] w-full overflow-hidden bg-white">
      <ElectricalPlug className="xl:block absolute left-[3%] top-[-30%] lgmaxmin:hidden " />
      <CircleIcon28pxSvg className="md:block absolute left-[47%] top-[15%] lgmaxmin:hidden" />
      <CircleIcon64pxSvg className="md:block absolute left-[18%] top-[80%] lgmaxmin:hidden" />
      <CircleIcon83pxSvg className="md:block absolute left-[70%] top-[5%] lgmaxmin:hidden" />
      <Xicon24pxSvg className="md:block absolute left-[25%] top-[45%] lgmaxmin:hidden" />
      <XIcon52pxSvg className="absolute left-[30%] top-[30%]  lg:block lgmaxmin:hidden" />
      <Xicon71pxSvg className="md:block absolute left-[70%] top-[80%] lgmaxmin:hidden" />
      <div className="flex flex-col items-center justify-center py-[150px] text-center sm:py-[50px]">
        <p className="text-primary text-[128px] font-semibold leading-tight sm:text-[64px]">
          404
        </p>
        <p className="text-primary text-[64px] font-bold leading-tight sm:text-[40px]">
          Page not found
        </p>
        <p className="text-2xl font-medium sm:text-xl">page not found</p>
        <div className="pt-10">
          <PrimaryButton onClick={() => navigate("/")}>
            go to home
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
